import { render } from "./LabelData.vue?vue&type=template&id=0f1d371e"
import script from "./LabelData.vue?vue&type=script&lang=js"
export * from "./LabelData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__